<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="会议名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.mtitle" placeholder="请输入会议名称"></el-input>
					</el-form-item>
					<el-form-item label="是否显示" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="显示" :value="1">显示</el-option>
							<el-option key="0" label="不显示" :value="0">不显示 </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择分类">
						<el-select v-model="searchInfo.mtype" filterable class="big" placeholder="请选择"
							@change="getStoreName">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option v-for="item in meettypelist" :key="item.id" :value="item.id"
								:label="item.typeName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun()">新增会议</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">

						<el-form-item label="会议标题">
							<span>{{ props.row.mtitle }}</span>
						</el-form-item>

						<el-form-item label="会议发布人">
							<span>{{ props.row.username }}</span>
						</el-form-item>
						<el-form-item label="会议举办城市">
							<span>{{ props.row.mhostCity}}</span>
						</el-form-item>
						<el-form-item label="详细地址">
							<span>{{ props.row.maddress}}</span>
						</el-form-item>
						<el-form-item label="坐标">
							<span>{{ props.row.mlatitudeLongitude}}</span>
						</el-form-item>
						<el-form-item label="参会人数">
							<span>{{ props.row.mattendPeople}}</span>
						</el-form-item>
						<el-form-item label="会议类别">
							<span>{{ props.row.typeName}}</span>
						</el-form-item>
						<el-form-item label="会议内容">
							<el-button size="small" type="text"
								@click="findDetail(props.row.introduction,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="报名截止时间">
							<span>{{ props.row.mregistrationDeadlineDatetime}}</span>
						</el-form-item>
						<el-form-item label="注意事项">
							<el-button size="small" type="text"
								@click="findDetail(props.row.mattention,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="banner图">
							<el-button size="small" type="text"
								@click="findDetail(props.row.mbanner,2)">点击查看</el-button>
						</el-form-item>

						<el-form-item label="是否报销车费">
							<span>{{ props.row.isFare?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="车费额度说明">
							<el-button size="small" type="text"
								@click="findDetail(props.row.fareAmount,1)">点击查看</el-button>
						</el-form-item>
						
						<el-form-item label="提供餐食">
							<span>{{ props.row.isProvideFood?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="是否收费">
							<span>{{ props.row.isCharge?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="收费说明">
							<el-button size="small" type="text"
								@click="findDetail(props.row.chargeDescription,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="餐食说明">
							<el-button size="small" type="text"
								@click="findDetail(props.row.provideFoodMemo,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="提供住宿">
							<span>{{ props.row.isProvideAccommodation?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="开启线上预约">
							<span>{{ props.row.isSubscribe?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="联系人">
							<span>{{ props.row.mcontacts }}</span>
						</el-form-item>
						<el-form-item label="联系电话">
							<span>{{ props.row.mcontactPhone }}</span>
						</el-form-item>
						<el-form-item label="联系邮箱">
							<span>{{ props.row.memail }}</span>
						</el-form-item>
						<el-form-item label="主办方">
							<el-button size="small" type="text"
								@click="findTag(props.row.meetingOrganizerList,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="承办方">
							<el-button size="small" type="text"
								@click="findTag(props.row.meetingOrganizerList,2)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="协办方">
							<el-button size="small" type="text"
								@click="findTag(props.row.meetingOrganizerList,3)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="赞助方">
							<el-button size="small" type="text"
								@click="findTag(props.row.meetingOrganizerList,4)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>


			<el-table-column prop="mtitle" label="会议标题" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="username" label="会议发布人" width="100px" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="mhostCity" label="会议举办城市" width="120px" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="mattendPeople" label="参会人数" width="100px" align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="mbeginDatetime" label="会议开始时间" width="120px"  align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="mendDatetime" label="会议结束时间" width="120px"  align="center"
				:show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="typeName" label="会议类别" width="100px"  align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isFare" label="报销车费" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<p v-if="scope.row.isFare==1">是</p>
					<p v-if="scope.row.isFare==0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="isProvideAccommodation" label="提供住宿" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<p v-if="scope.row.isProvideAccommodation==1">是</p>
					<p v-if="scope.row.isProvideAccommodation==0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="isProvideFood" label="提供餐食" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<p v-if="scope.row.isProvideFood==1">是</p>
					<p v-if="scope.row.isProvideFood==0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="isSubscribe" label="开启线上报名登记" width="150px" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<p v-if="scope.row.isSubscribe==1">是</p>
					<p v-if="scope.row.isSubscribe==0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<p v-if="scope.row.status==1">显示</p>
					<p v-if="scope.row.status==0">不显示</p>
				</template>
			</el-table-column>
			<el-table-column prop="updateBy" label="更新人" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<!-- <el-table-column prop="checkTime" label="审核时间" width="100px" sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column prop="createDate" label="创建时间" width="100px" align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateDate" label="更新时间" width="100px" align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center" width="150px" >
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row)">编辑</el-button>　　
					<el-button size="small" type="text" @click="toDelete(scope.row)">删除</el-button>
					<!-- <el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
				<div v-if="detailType == 2"
					style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
					<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
				</div>
			</div>
			<div style="text-align: center;margin-top:30px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="">
						<div style="text-align: left;">
						</div>


						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="会议标题" style="width: 40%;">
								<el-input type="text" clearable v-model="storeGoodsInfo.mtitle" placeholder="请输入会议标题" />
							</el-form-item>
							<el-form-item label="会议类别" style="margin-left: 40px;">
								<el-select v-model="storeGoodsInfo.mtype" filterable class="big" placeholder="请选择"
									@change="getStoreName">
									<el-option v-for="item in meettypelist" :key="item.id" :value="item.id"
										:label="item.typeName">
									</el-option>
								</el-select>
							</el-form-item>

						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="会议banner">
								<!-- 图片上传 -->
								<el-upload class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
									:before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
									<img style="width: 100px;height: 100px;" v-if="mbanner" :src="mbanner"
										class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="主办方">
								<el-tag style="margin-left: 10px;" @click="edittag(item,'主办方')" :key="item.organizerName" v-for="item in Atags"
									closable :disable-transitions="false" @close="AhandleClose(item)">
									{{item.organizerName}}
								</el-tag>
								<el-button class="button-new-tag" size="small" @click="showTag(1,'主办方')">添加
									主办方</el-button>
							</el-form-item>
							<el-form-item label="承办方">
								<el-tag style="margin-left: 10px;" @click="edittag(item,'承办方')" :key="item.organizerName" v-for="item in Btags"
									closable :disable-transitions="false" @close="BhandleClose(item)">
									{{item.organizerName}}
								</el-tag>
								<el-button class="button-new-tag" size="small" @click="showTag(2,'承办方')">添加
									承办方</el-button>
							</el-form-item>
							<el-form-item label="协办方">
								<el-tag style="margin-left: 10px;" @click="edittag(item,'协办方')" :key="item.organizerName" v-for="item in Ctags"
									closable :disable-transitions="false" @close="ChandleClose(item)">
									{{item.organizerName}}
								</el-tag> 
								<el-button class="button-new-tag" size="small" @click="showTag(3,'协办方')">添加
									协办方</el-button>
							</el-form-item>
							<el-form-item label="赞助方">
								<el-tag style="margin-left: 10px;" @click="edittag(item,'赞助方')" :key="item.organizerName" v-for="item in Dtags"
									closable :disable-transitions="false" @close="DhandleClose(item)">
									{{item.organizerName}}
								</el-tag>
								<el-button class="button-new-tag" size="small" @click="showTag(4,'赞助方')">添加
									赞助方</el-button>
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="会议时间">
								<el-col :span="11">
									<el-date-picker v-model="dateValue" type="datetimerange"
										:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" align="right">
									</el-date-picker>
								</el-col>
							</el-form-item>
						</div>
					</div>
					
						<el-form-item label="会议地址">
							<el-select clearable filterable v-model="storeGoodsInfo.mhostCity" placeholder="请选择参会城市"
								style="width:180px;margin-right:10px;" @change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.name"></el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="详细地址" class="redItem" style="width: 100%;">
							<el-input readonly type="text" clearable  style="width:600px;" v-model="storeGoodsInfo.maddress" placeholder="请输入详细地址" />
							<el-button icon="el-icon-position" @click="openMap()" type="primary"></el-button>
						</el-form-item>
					
					<div>

						<el-form-item label="参会人数" class="redItem" style="">
							<el-select clearable filterable v-model="storeGoodsInfo.mattendPeople" placeholder="请选择参会人数"
								style="width:180px;margin-right:10px;" >
								<el-option  label="10-30" value="10-30"></el-option>
								<el-option  label="30-60" value="30-60"></el-option>
								<el-option  label="60-100" value="60-100"></el-option>
								<el-option  label="100-200" value="100-200"></el-option>
								<el-option  label="200-300" value="200-300"></el-option>
								<el-option  label="300-500" value="300-500"></el-option>
								<el-option  label="500+" value="500+"></el-option>
							</el-select>
						
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: flex-start;">
						<el-form-item label="是否报销车费" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isFare" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item label="报销说明" v-if="storeGoodsInfo.isFare" style="width: 70%;">
							<el-input type="textarea" clearable v-model="storeGoodsInfo.fareAmount"
								placeholder="请输入车费报销额度说明" />
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: flex-start;">
						<el-form-item label="是否提供住宿" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isProvideAccommodation" :active-value="true"
								:inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item label="住宿说明" v-if="storeGoodsInfo.isProvideAccommodation" style="width: 70%;">
							<el-input type="textarea" clearable v-model="storeGoodsInfo.provideAccommodationMemo"
								placeholder="请输入住宿说明" />
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: flex-start;">
						<el-form-item label="是否提供餐食" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isProvideFood" :active-value="true"
								:inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item label="餐食说明" v-if="storeGoodsInfo.isProvideFood" style="width: 70%;">
							<el-input type="textarea" clearable v-model="storeGoodsInfo.provideFoodMemo"
								placeholder="请输入餐食说明" />
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: flex-start;">
						<el-form-item label="是否开启线上预约报名" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isSubscribe" :active-value="true"
								:inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item v-if="storeGoodsInfo.isSubscribe" label="报名截至时间" style="width: 70%;">
							<el-date-picker
							      v-model="storeGoodsInfo.mregistrationDeadlineDatetime"
							      type="datetime"
								value-format="yyyy-MM-dd HH:mm:ss"
							      placeholder="选择日期时间">
							    </el-date-picker>
						</el-form-item>
					</div>
				
					<div style="display: flex;justify-content: flex-start;">
						<el-form-item label="是否收费" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isCharge" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item v-if="storeGoodsInfo.isCharge" label="收费说明" style="width: 70%;">
							<el-input type="textarea" clearable v-model="storeGoodsInfo.chargeDescription" placeholder="请输入收费说明" />
						</el-form-item>
					
					</div>
					<el-form-item v-if="storeGoodsInfo.isCharge" label="收费金额" style="width: 35%;margin-right: 35%;">
						<el-input type="text" clearable   v-model="storeGoodsInfo.chargeAmount" placeholder="请输入收费金额" />
					</el-form-item>
					<el-form-item label="是否显示" class="redItem" style="flex: 25%;">
						<el-switch v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
					
					
					
					
					
					<el-form-item label="会议注意事项" style="width: 50%;">
						<el-input type="textarea" clearable v-model="storeGoodsInfo.mattention" placeholder="请输入住宿说明" />
					</el-form-item>
					
					
					
					<div style="display: flex;">
						<el-form-item label="联系人" style="width: 30%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.mcontacts" placeholder="请输入联系人" />
						</el-form-item>
						<el-form-item label="联系电话" style="width: 30%;margin-left: 5%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.mcontactPhone"
								placeholder="请输入联系电话" />
						</el-form-item>
						<el-form-item label="联系邮箱" style="width: 30%;margin-left: 5%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.memail" placeholder="请输入联系邮箱" />
						</el-form-item>
					</div>
					<div style="width: 100%;">
						<div style="text-align: start;margin: 10px;">会议内容</div>
						<el-form-item style="width: 100%;">
							<div id="lpc-quill" class="quill" style="width: 100%;">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.introduction" ref="myQuillEditor" class="editer"
								style="height:600px"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;margin-top:80px">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增会议'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑会议'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<el-dialog style="float:rigin" title="审核驳回" :closeOnClickModal="false" :visible.sync="editDialogVisible1"
			width="50%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
						<el-input style="width: 100%;" v-model="rejectReason" placeholder="请输入驳回原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible1=false;loading=false">取 消</el-button>
				<el-button @click="shenhe()" :loading="loading2" type="primary">确 定</el-button>
			</div>
		</el-dialog>
		<!-- <el-dialog style="float:rigin" :title="tagtitle" :closeOnClickModal="false" :visible.sync="tagDialogVisible"
			width="50%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="名称:" class="redItem" style="width: 100%;">
						<el-input :disabled="lookflag" style="width: 100%;" v-model="organizerName" placeholder="请输入名称">
						</el-input>
					</el-form-item>
					<el-form-item label="Logo">
					
						<el-upload :disabled="lookflag" class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
							:before-upload="beforeAvatarUpload" :on-success="onSuccess1" :show-file-list="false">
							<img style="width: 100px;height: 100px;" v-if="organizerLogo" :src="organizerLogo"
								class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="是否显示" class="redItem" style="flex: 25%;">
						<el-switch :disabled="lookflag" v-model="status" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;" v-if="!lookflag">
				<el-button @click="tagDialogVisible=false;loading3=false">取 消</el-button>
				<el-button @click="suretag()" :loading="loading3" type="primary">确 定</el-button>
			</div>
			<div style="text-align: center;" v-else>
				<el-button @click="tagDialogVisible=false;loading3=false">关  闭</el-button>
			
			</div>
		</el-dialog> -->
		
		<el-dialog style="float:rigin" :title="tagtitle" :closeOnClickModal="false" :visible.sync="tagDialogVisible"
			width="50%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="名称:" class="redItem" style="width: 100%;">
						<el-input  style="width: 100%;" v-model="organizerName" placeholder="请输入名称">
						</el-input>
					</el-form-item>
					<el-form-item label="Logo">
						
						<el-upload  class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
							:before-upload="beforeAvatarUpload" :on-success="onSuccess1" :show-file-list="false">
							<img style="width: 100px;height: 100px;" v-if="organizerLogo" :src="organizerLogo"
								class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="是否显示" class="redItem" style="flex: 25%;">
						<el-switch  v-model="status" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="tagDialogVisible=false;loading3=false">取 消</el-button>
				<el-button v-if="tagflag" @click="xgtag()" :loading="loading3" type="primary">修 改</el-button>
				<el-button v-else @click="suretag()" :loading="loading3" type="primary">确 定</el-button>
				
				
			</div>
		
		</el-dialog>
		<el-dialog style="float:rigin" :title="tagtitles" :closeOnClickModal="false" :visible.sync="tagDialogVisibles"
			width="60%">
			<div  style="display: flex;align-items: center;flex-wrap: wrap;">
				<div style="display: flex;justify-content: flex-start;flex-direction: column;" 
				v-for="(item,index) in showtags" :key="index">
					<div>
						{{tagtitles}}名称：{{item.organizerName}}
					</div>
					<div style="display: flex;margin: 30px;">
						Logo：<img :src="item.organizerLogo" alt="" style="width: 100px;height: 100px;border-radius: 10px;">
					</div>
					<div style="display: flex;margin: 30px;">
						是否显示<el-switch disabled v-model="item.status" :active-value="true" :inactive-value="false">
						</el-switch>
					</div>
				</div>
				
			</div>
			
			<div style="text-align: center;" >
				<el-button @click="tagDialogVisibles=false;loading3=false">关  闭</el-button>
			
			</div>
		</el-dialog>
		 <MapSelect ref="ms" @on-select="selectAddress" />	
	</div>
</template>

<script>
	import {getipjw} from '@/api/axios.js'
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('meet');
	
	var Alist = []
	var Blist = []
	var Clist = []
	var Dlist = []
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};
import MapSelect from '@/components/MapSelect'
	export default {
		components: {
			//使用编辑器
			quillEditor,
			MapSelect
		},
		data() {
			return {
				asd:{},
				ip:'',//外网ip
				mainForm: {
							address: '',
							lat: '',
							lng: '',
						},
				Atag: [],
				tagDialogVisibles:false,
				tagtitles:'',
				loading3: false,
				lookflag:false,
				tagform: {},
				organizerName: '',
				organizerType: '',
				tagtitle: '',
				rejectReason: '',
				tagDialogVisible: false,
				tagid:'',
				buy: {
					goodId: null,

					ids: '',
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: null,
					goodsImages: ""
				},
				auditDialogVisibleInfo: false,
				auditTitle: '',
				reason: '',
				topType: '',
				stoId: '',
				editDialogVisible1: false,
				setUpBuyVisible: false,
				goodsImages: [],
				userList: [],
				fileList: [],
				fileList1: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				loading2: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,
				meettypelist: [],

				classGoods1Id: "",

				classGoods1Id1: "",
				dateValue: '',
				storeGoodsInfo: {
					isProvideAccommodation: false,
					isSubscribe: false,
					isProvideFood: false,
					status: false,
					isFare: false,
					maddress:'',
					mlatitudeLongitude:''
				},
				showtags:[],
				storeGoodsInfo1: {

				},
				pickerOptions: {
					shortcuts: [{
						text: '最近一天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 1);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近两天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 2);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}],
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7;
					},

				},
				provinceList: {},

				districtList: {},
				storeGoodsId: '', //授权用户id
				storeList: [],
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				mtype: '',
				selectStoreName: [],
				isSearchShow: false,

				cityList: {},
				districtList: {},
				storeNameId: '', //店铺iD

				searchInfo: {
					status: '',
					mtype: '',
				},
				mbanner: '',
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				tagindex: '',
				Atags: [],
				Btags: [],
				tagname:'',
				Ctags: [],
				tagflag:false,
				Dtags: [],
				tagindex:'',
				auditFlag: false, //审核记录弹窗
				auditLogging: {}, //审核记录
				auditPage: {
					pageNum: 1,
					pageSize: 6,
					id: 122
				},
				auditLoading: false,
				organizerLogo: '',
				meetingOrganizerList: [],
				status: 0,

				addLoading: false,
				sureLoading: false,
			};
		},

		computed: {

			pv() {
				return (this.storeGoodsInfo.costPrice / this.storeGoodsInfo.price).toFixed(4)
			},
			pv1() {
				return (this.storeGoodsInfo1.costPrice / this.storeGoodsInfo1.price).toFixed(4)
			},
			intermediatorNum() {
				return (this.storeGoodsInfo.intermediatorRate * this.storeGoodsInfo.price).toFixed(2)
			},
			intermediatorNum1() {
				return (this.storeGoodsInfo1.intermediatorRate * this.storeGoodsInfo1.price).toFixed(2)
			}
		},
		methods: {
			// 打开地图弹窗
				openMap() {
					
					this.$refs.ms.show();
					// 根据省市区设置初始值
					this.$refs.ms.setLocationByAddress(this.mainForm.address);
					// 根据经纬度设置初始值
					if(this.storeGoodsInfo.mlatitudeLongitude){
						this.$refs.ms.setLocationByLatLng(this.storeGoodsInfo.mlatitudeLongitude.split(',')[0],this.storeGoodsInfo.mlatitudeLongitude.split(',')[1]);
					}else{
						// console.log(this.mainForm.lat,this.mainForm.lng);
					this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
					}
					
				},
				
				// 地址选择后的回调函数
				selectAddress(address, lat, lng) {
					this.mainForm.address = address;
					this.storeGoodsInfo.maddress=address
					this.storeGoodsInfo.mlatitudeLongitude=lat+','+lng
				
				},
			addressSelectHandler(){
				// console.log(123);
			},
			edittag(item,name){
				
				this.tagDialogVisible = true
				this.tagid=item.id
				this.tagname=item.organizerName
				this.tagflag=true
				// console.log(this.tagid);
				this.lookflag=true
				this.tagtitle = name
				this.organizerType= item.organizerType,
				this.organizerName= item.organizerName,
				this.organizerLogo= item.organizerLogo,
				this.status= item.status
				
			},
			xgtag(){
			
				if(this.organizerType==1){
					
					if(this.tagid){
						// console.log(123);
						this.Atags.forEach((item,index)=>{
							if(item.id==this.tagid){
								this.$set(this.Atags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
					this.tagDialogVisible = false
					}else{
						this.Atags.forEach((item,index)=>{
							if(item.organizerName==this.tagname){
								this.$set(this.Atags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
						this.tagDialogVisible = false
					}
				}
				if(this.organizerType==2){
					if(this.tagid){
						// console.log(123);
						this.Btags.forEach((item,index)=>{
							if(item.id==this.tagid){
								this.$set(this.Btags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
					this.tagDialogVisible = false
					}else{
						this.Btags.forEach((item,index)=>{
							if(item.organizerName==this.tagname){
								this.$set(this.Btags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
						this.tagDialogVisible = false
					}
				}
				if(this.organizerType==3){
					if(this.tagid){
						// console.log(123);
						this.Ctags.forEach((item,index)=>{
							if(item.id==this.tagid){
								this.$set(this.Ctags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
					this.tagDialogVisible = false
					}else{
						this.Ctags.forEach((item,index)=>{
							if(item.organizerName==this.tagname){
								this.$set(this.Ctags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
						this.tagDialogVisible = false
					}
				}
				if(this.organizerType==4){
					if(this.tagid){
						// console.log(123);
						this.Dtags.forEach((item,index)=>{
							if(item.id==this.tagid){
								this.$set(this.Dtags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
					this.tagDialogVisible = false
					}else{
						this.Dtags.forEach((item,index)=>{
							if(item.organizerName==this.tagname){
								this.$set(this.Dtags,index,{
									id:this.tagid,
									organizerType: this.organizerType,
									organizerName: this.organizerName,
									organizerLogo: this.organizerLogo,
									status: this.status,
								})
							}
						})
						this.tagDialogVisible = false
					}
				}
				
			},
			suretag() {
				if (this.organizerType == 1) {
					this.Atags.push({
						organizerType: this.organizerType,
						organizerName: this.organizerName,
						organizerLogo: this.organizerLogo,
						status: this.status,
						
					})
				} else if (this.organizerType == 2) {
					this.Btags.push({
						organizerType: this.organizerType,
						organizerName: this.organizerName,
						organizerLogo: this.organizerLogo,
						status: this.status
					})
				} else if (this.organizerType == 3) {
					this.Ctags.push({
						organizerType: this.organizerType,
						organizerName: this.organizerName,
						organizerLogo: this.organizerLogo,
						status: this.status
					})
				} else if (this.organizerType == 4) {
					this.Dtags.push({
						organizerType: this.organizerType,
						organizerName: this.organizerName,
						organizerLogo: this.organizerLogo,
						status: this.status
					})
				}
				this.organizerType=''
				this.organizerName=''
				this.organizerLogo=''
				this.status=false

				this.tagDialogVisible = false

			},
			showTag(index, name) {
				this.organizerType=''
				this.organizerName=''
				this.tagid=''
				this.tagflag=false
				this.organizerLogo=''
				this.status=false
				this.lookflag=false
				this.tagDialogVisible = true
				this.tagtitle = name
				this.organizerType = index
			},
			AhandleClose(tag) {
				
				this.Atags.splice(this.Atags.indexOf(tag), 1);
				this.$api.delcbf(tag.id)
			},
			BhandleClose(tag) {
				this.Btags.splice(this.Btags.indexOf(tag), 1);
				this.$api.delcbf(tag.id)
			},
			ChandleClose(tag) {
				this.Ctags.splice(this.Ctags.indexOf(tag), 1);
				this.$api.delcbf(tag.id)
			},
			DhandleClose(tag) {
				this.Dtags.splice(this.Dtags.indexOf(tag), 1);
				this.$api.delcbf(tag.id)
			},
			provinceFocus() {

			},

			bohui(id) {
				this.ids = id
				this.editDialogVisible1 = true
			},
			tonguo() {

			},
			//导出
			downloadFile() {
				let data = {
					goodsCode: this.searchInfo.goodsCode ? this.searchInfo.goodsCode : "",
					status: this.searchInfo.status ? this.searchInfo.status : "",
					orderType: this.searchInfo.orderType ? this.searchInfo.orderType : "",
					goodsName: this.searchInfo.goodsName ? this.searchInfo.goodsName : "",
					isDh: this.searchInfo.isDh ? this.searchInfo.isDh : "",
					// startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					// cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				//   console.log(data);
				this.$api.commodityExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			getUserList(e) {
				// console.log('输入的用户明--',e);
				this.$api.getUserList(this.$encrypt({
					username: e
				})).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.userList = res.data
						// console.log(res);
						this.loading = false
					}

				})
			},
			// onSuccess(response, file, fileList) {
			// 	// console.log(res)
			// 	this.goodsImages.push(response.message);
			// 	// console.log("asda",response,this.goodsImages)
			// },
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.mbanner = response.message;
			},
			onSuccess1(response, file, fileList) {
				// console.log(response);
				this.organizerLogo = response.message;

			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},

			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			findTag(item,index){
					this.tagDialogVisibles=true
					this.showtags=item.filter(item=>item.organizerType==index)
					// console.log(this.showtags);
					this.tagtitles=index==1?'主办方':index==2?'承办方':this.index==3?'协办方':'赞助方'
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//店铺审核
			editgoodsInfoCheck(authStatus) {
				if (authStatus == 2) {
					//通过驳回
					this.loading2 = true
					var data = {
						id: this.ids,
						status: authStatus,
						remark: this.reason
					}
				} else {
					this.loading = true
					//通过审核
					var data = {
						id: this.ids,
						status: authStatus
					}
				}
				this.$api.storeGoodsReview(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.editDialogVisible1 = false
						this.reason = ''
						this.loading2 = false
						this.loading = false
						this.getStoreGoodsList()
					} else {
						this.loading = false
						this.loading2 = false
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			shenhe() {
				this.$api.auditById({
					id: this.ids,
					status: 2,
					rejectReason: this.rejectReason
				}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreGoodsList();
						this.editDialogVisible1 = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				var str = "此操作将审核通过该会议, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.auditById({
						id: id,
						status: 1
					}).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});



			},
			// 店铺编辑弹窗
			dialogVisibleFun(item) {
				this.dateValue = ''
				this.mbanner = ''
				this.Atags=[]
				this.Btags=[]
				this.Ctags=[]
				this.Dtags=[]
				this.storeGoodsInfo = {
					isProvideAccommodation: false,
					isSubscribe: false,
					isProvideFood: false,
					status: false,
					isFare: false,
					maddress:''
				}
				
				this.dialogVisibleFunName = "新增会议"
				this.dialogVisible = true;

				if (item.id) {

					this.dialogVisibleFunName = "编辑会议"
					this.storeGoodsId = item.id
					this.dateValue = [item.mbeginDatetime, item.mendDatetime]

					this.$api.meetdetail(this.storeGoodsId).then((res) => {
					
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							res.data.meetingOrganizerList.forEach(item=>{
								if(item.organizerType==1){
									this.Atags.push(item)
								}else if(item.organizerType==2){
									this.Btags.push(item)
								}else if(item.organizerType==3){
									this.Ctags.push(item)
								}else if(item.organizerType==4){
									this.Dtags.push(item)
								}
							})
						
							this.mbanner = res.data.mbanner

							this.mtype = res.data.mtype
							// console.log(this.meettypelist);
						}
					})
				}
			},
			//添加商品
			add() {

				this.storeGoodsInfo.mbeginDatetime = this.dateValue[0]
				this.storeGoodsInfo.mendDatetime = this.dateValue[1]
				this.meetingOrganizerList = this.meetingOrganizerList.concat(this.Atags, this.Btags, this.Ctags, this
					.Dtags)
				this.addLoading = true;
				this.$api.addmeet({
					...this.storeGoodsInfo,
					mtype: this.mtype,
					meetingOrganizerList: this.meetingOrganizerList,
					mbanner: this.mbanner

				}).then((res) => {

					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.searchInfo = {}
						this.Atags = []
						this.Btags = []
						this.Ctags = []
						this.Dtags = []
						this.organizerType = ''
						this.organizerName = ''
						this.organizerLogo = ''
						this.status=''
						this.storeGoodsInfo = {}
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
						
					}
					this.addLoading = false;
				})
			},
			//编辑商品
			sure() {
				this.meetingOrganizerList=[]
				this.storeGoodsInfo.mbeginDatetime = this.dateValue[0]
				this.storeGoodsInfo.mendDatetime = this.dateValue[1]
				this.meetingOrganizerList = this.meetingOrganizerList.concat(this.Atags, this.Btags, this.Ctags, this
					.Dtags)
				this.sureLoading = true;
				this.$api.updatemeet({
					...this.storeGoodsInfo,
					mtype: this.mtype,
					mbanner: this.mbanner,
					meetingOrganizerList: this.meetingOrganizerList,
					id: this.storeGoodsId
				}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.searchInfo = {}
						this.storeGoodsInfo = {}
						this.Atags=[]
						this.Btags=[]
						this.Ctags=[]
						this.Dtags=[]
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}

					this.sureLoading = false;
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该会议, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deletemeet(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			auditPageChange(data) { //审核记录
				this.auditPage.pageNum = data
				this.getAuditLogging()
			},
			auditHandleSizeChange(val) { //审核记录
				this.auditPage.pageSize = val
				this.getAuditLogging()
			},
			getAuditLogging() { //查询审核记录

				this.$api.findshenhgoods(this.auditPage).then((res) => { //商品列表

					// console.log(res);
					if (res.state == 'success') {
						this.auditLogging = res.data
						this.auditLoading = false
					}
				})
			},
			auditClick(item) {
				// console.log('商品审核回显--', item)
				this.auditPage.goodsId = item.id
				this.getAuditLogging()
				this.auditFlag = true;
			},
			getStoreGoodsList() {
				this.loading = true
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				this.$api.meetlist(this.searchInfo).then((res) => { //商品列表

					// console.log(res);
					if (res.state == 'success') {
						this.goodsList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},


			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			inputHandler() {
				this.isSearchShow = true
				if (this.storeGoodsInfo.joint === '') {
					this.isSearchShow = false
				}

				this.getUserList(this.storeGoodsInfo.joint)
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},

			getStoreName(e) {

				this.mtype = e
			},
			selectStores(item) {
				this.storeGoodsInfo.intermediatorUserId = item.inviterUserId
				this.storeGoodsInfo.username = item.username
				this.storeGoodsInfo.phone = item.phone

				this.storeGoodsInfo.joint = item.inviterUserId + '~' + item.username + '~' + item.phone
				this.isSearchShow = false
				// console.log('下拉点击item---', item)
				// console.log('点击this.storeGoodsInfo---', this.storeGoodsInfo)
			},
			selectStore() {
				this.$api.selectStoreList().then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.selectStoreName = res.data
					} else {
						this.$message.error(res.message);
					}
				})

			},
			preAudit(e) { // 审核前
				// console.log(JSON.parse(e))
				this.auditTitle = '审核前'
				this.auditDialogVisibleInfo = true;
				this.storeGoodsInfo = JSON.parse(e)
				this.storeGoodsInfo.images = this.storeGoodsInfo.images.split(',')
			},
			afterAudit(e) { // 审核后
				// console.log(JSON.parse(e))
				this.auditTitle = '审核后'
				this.auditDialogVisibleInfo = true;
				this.storeGoodsInfo = JSON.parse(e)
				this.storeGoodsInfo.images = this.storeGoodsInfo.images.split(',')
				// console.log(this.storeGoodsInfo)
			},
			classGoods1() {

			},
			getExternalIP() {
			  var xhttp = new XMLHttpRequest();
				let that=this
			  xhttp.onreadystatechange = function() {
			    if (this.readyState == 4 && this.status == 200) {
			      var response = JSON.parse(this.responseText);
			  
					localStorage.setItem('ip',response.ip)
					localStorage.getItem('ip')
					that.$api.getGaoDeMapApi(localStorage.getItem('ip')).then(res=>{
						// console.log(JSON.parse(res.message).result);
						that.mainForm.lat=JSON.parse(res.message).result.location.lat
						that.mainForm.lng=JSON.parse(res.message).result.location.lng
						
					})
			    }
			  };
			
			  xhttp.open("GET", "https://api.ipify.org?format=json", true);
			  xhttp.send();
				
			},
			
		
		},
		
		created() {
		
			this.getExternalIP();
			
			  
			
			this.$api.getFirstLetter({
				level: 2
			}).then((res) => {
				if (res.state == 'success') {

					this.provinceList = res.data
				}
			})

			this.$api.meettype().then(res => { //
				// console.log(res);
				if (res.state == 'success') {
					this.meettypelist = res.data;
				}
			})
			this.selectStore()
			this.getStoreGoodsList();


		}

	};
</script>

<style scoped lang="less">
	.demo-table-expand {
		font-size: 0;
		margin-left: 60px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	/deep/.el-input__inner {
		color: black !important;
	}

	/deep/.el-textarea__inner {
		color: black !important;
	}

	/deep/ .ql-toolbar {
		width: 100%;
		text-align: left;
	}

	/deep/.ql-editor {
		height: 648px;
	}

	.button-new-tag {
		margin-left: 10px;
	}
</style>